// extracted by mini-css-extract-plugin
export var fadeInOut = "_q-3";
export var icon = "_q-4";
export var savedIndicator = "_q-2";
export var savingIndicator = "_q-0";
export var spin = "_q-1";